import React from 'react';
import { TabContent, CardImg, TabPane, Nav, NavItem, NavLink, Row, Col, Button, Input, FormFeedback,
    FormGroup, Label, Form } from 'reactstrap';
import noImage from 'assets/img/users/no-image.jpg';
import { connect } from 'react-redux';
import { UserAction, ChatAction } from 'redux/actions';
import { useParams } from "react-router-dom";
import Searches from 'pages/posts/searches';
import Favourites from 'pages/posts/favourites';
import PopupWindow from 'components/ModalPopup';
import { MdModeEdit, MdDone } from 'react-icons/md';
import { profileFormvalidations, ChangeAppPassword } from 'form-validations';
import { DateFormat } from 'hooks';
import DatePickerComp from 'components/DatePicker/DatePicker';
import { checkPermissions } from 'hooks';
import Conversatation from './conversatation';
import Skeleton from '@mui/material/Skeleton';
import { Map, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import markerIconImage from 'assets/img/marker-icon.png';
import L from "leaflet";
import Followers from './followers';
import Following from './following';
import AutoFollowBtn from './autoFollowBtn';
import RssFeedButton from 'components/RssFeedButton';

const ProfilePage = (props) => {
    const [open, setOpen] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState('ABOUT');
    const [requestText, setRequestText] = React.useState(null);
    const { userId } = useParams();
    const isFirstRender = React.useRef(true);
    const [editMode, setEditMode] = React.useState({});
    const [values, setValues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isValid, setIsValid] = React.useState(true);

    let [isPasswordValid, setIsPasswordValid] = React.useState(true);
    const [passwordValues, setPasswordValues] = React.useState({});
    const [openPassword, setOpenPassword] = React.useState(false);

    let [isSubmitted, setIsSubmitted] = React.useState(false);

    const markerIcon = new L.Icon({
        iconUrl: markerIconImage,
        iconSize: [25, 41],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40]
    });

    React.useEffect(() => {
        if (isFirstRender.current) {
            props.getUserProfile({ id: userId });
            isFirstRender.current = false;
        }
    })

    React.useEffect(() => {
        props.getUserProfile({ id: userId });
        setActiveTab('ABOUT');
    }, [userId]);


    React.useEffect(() => {
        const validationErrors = ChangeAppPassword(passwordValues);
        isPasswordValid = Object.keys(validationErrors).length === 0;
        setIsPasswordValid(isPasswordValid);
        setErrors(validationErrors);
    }, [passwordValues]);
    

    React.useEffect(() => {
        const validationErrors = profileFormvalidations(values);
        isValid = Object.keys(validationErrors).length === 0;
        setIsValid(isValid);
        setErrors(validationErrors);
    }, [values]);

    const handleTab = (tab) => {
        setActiveTab(tab)

    }

    const handleSubmit = () => {
        setIsSubmitted(true);
        if (isPasswordValid) {
            const payload = { ...passwordValues };
            payload['user_id'] = userId;
            props.changeAppPassword(payload);
        }
    }

    React.useEffect(() => {
        if (props.accountSuspended) {
            setOpen(false);
            props.getUserProfile({ id: userId });
        }
    }, [props.accountSuspended])

    React.useEffect(() => {
        setOpenPassword(false);
    }, [props.appPasswordChanged])


    

    const handleEdit = (targetName, targetValue) => {
        setEditMode({
            ...editMode, [targetName]: targetValue
        });
        if (!targetValue) {
            props.updateProfile({ id: userId, [targetName]: values[`${targetName}`] })
        }
    }

    React.useEffect(() => {
        if (props.user) {
            setValues(props.user)
        }
    }, [props.user]);

    React.useEffect(() => {
        if (props.profileUpdated) {
            props.getUserProfile({ id: userId });
        }
    }, [props.profileUpdated]);

    const handleChange = (event) => {
        setValues({
            ...values, [event.target.name]: event.target.value
        })
    };

    const handlePasswordChange = (event) => {
        setPasswordValues({
            ...passwordValues, [event.target.name]: event.target.value
        })
    };

    const onDateChange = (date, name) => {
        if (date) {
            setValues({
                ...values, [name]: DateFormat(date, 'YYYY-MM-DD')
            })
        }
    }


    const profileData = () => {
        const columns = [
            { label: 'Name', name: 'name', type: 'text' },
            { label: 'Gender', name: 'gender', type: 'select', options: ['male', 'female'] },
            { label: 'Email', name: 'email', type: 'text' },
            { label: 'Username', name: 'username', type: 'text' },
            { label: 'Phone', name: 'phone', type: 'text' },
            { label: 'Date of Birth', name: 'dob', type: 'date' },
            { label: 'Address', name: 'address', type: 'text' },
            { label: 'Current Location', name: 'current_location', type: 'text' },
        ];
        return columns.map((item, index) => {
            return (
                <Row key={index}>
                    <Col sm="4" xs={3}>
                        {item.label}:
                    </Col>
                    <Col sm="8" xs={9}>
                        {editMode[`${item.name}`] ? <div style={{ display: 'inline-flex' }}>
                            <div>
                                {(item.type === 'select') ?
                                    <Input
                                        type="select"
                                        style={{ width: 400 }}
                                        name={item.name}
                                        id={item.name}
                                        onChange={handleChange}>
                                        <option value="">Select Gender</option>
                                        {item.options.map((optionText) => <option value={optionText} selected={(values[`${item.name}`] === optionText) ? true : false}>{optionText}</option>)}
                                    </Input>
                                    : (item.type === 'date') ?
                                        <DatePickerComp
                                            selected={new Date(values[`${item.name}`])}
                                            onDateChange={(date) => onDateChange(date, item.name)}
                                        />



                                        : <Input
                                            style={{ width: 400 }}
                                            type="text"
                                            name={item.name}
                                            id={item.name}
                                            onChange={handleChange}
                                            autoComplete={'off'}
                                            value={values[`${item.name}`]}
                                        />

                                }
                                {(!values[`${item.name}`]) && <FormFeedback >{errors[`${item.name}`]} </FormFeedback>}
                            </div>
                            {(values[`${item.name}`] && !errors[`${item.name}`]) && <MdDone style={{ marginTop: 3, borderRadius: 5, border: '1px solid', color: '#00aee4', marginLeft: 10, cursor: 'pointer' }} size={30} onClick={() => handleEdit(item.name, false)} />}
                        </div>
                            : <>
                                {
                                    (props.profileLoading) ?
                                        <div style={{ display: 'flex' }}>
                                            <Skeleton variant="rectangular" width={150} height={30} style={{ borderRadius: 5 }} />
                                            <Skeleton variant="rectangular" width={30} height={30} style={{ borderRadius: 5, marginLeft: 10 }} />
                                        </div>
                                        : <>
                                            <span>{values[`${item.name}`]}</span>
                                            <span>{checkPermissions(props.loginData, 'update_profile') && <MdModeEdit size={25} style={{ borderRadius: 5, border: '1px solid', cursor: 'pointer', color: '#00aee4', marginLeft: 10 }} onClick={() => handleEdit(item.name, true)} />}</span>
                                        </>
                                }
                            </>
                        }
                    </Col>
                </Row>
            );

        })
    }

    return (
        <Row>
            <Col sm="12" lg="2" className="profile-image">
                {props.profileLoading ? <Skeleton className="profile-pic-skeleton" animation="wave" variant="rectangular" width={150} height={150} />
                    : <CardImg
                        className="card-img-left profile-pic"
                        src={(props.user && props.user.avatar) ? props.user.avatar : noImage}
                        style={{ width: 150, height: 150 }}
                    />
                }

{checkPermissions(props.loginData, 'change_app_password') ?
                <PopupWindow buttonStyle={{ marginTop: 10, width: '95%' }} handlePopup={(popup) => { setOpenPassword(popup) }} openWindow={openPassword} title={'Change Password'} launchButtonText={'Change Password'} >
                    <div>
                        <Form>
                            <FormGroup>
                                <Label for={'password'}>{'New Password'}</Label>
                                <Input
                                    type="password"
                                    name="password"
                                    id="password"
                                    onChange={handlePasswordChange}
                                    autoComplete={'off'}
                                    value={(passwordValues && passwordValues.password) ? passwordValues.password : ''}
                                />
                                {(isSubmitted && errors.password && !passwordValues.password) && <FormFeedback >{errors.password} </FormFeedback>}
                            </FormGroup>
                            <FormGroup>
                                <Label for={'password_confirmation'}>{'Confirm Password'}</Label>
                                <Input
                                    type="password"
                                    name="password_confirmation"
                                    id="password_confirmation"
                                    onChange={handlePasswordChange}
                                    autoComplete={'off'}
                                    value={(passwordValues && passwordValues.password_confirmation) ? passwordValues.password_confirmation : ''}
                                />
                                {(isSubmitted && errors.password_confirmation && !passwordValues.password_confirmation) && <FormFeedback >{errors.password_confirmation} </FormFeedback>}
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                            <Button
                                size="lg"
                                color="primary"
                                className="border-0"
                                block
                                onClick={handleSubmit}>
                                Change
                            </Button>
                            </Col>
                            <Col>
                            <Button
                                size="lg"
                                color="danger"
                                className="border-0"
                                block
                                onClick={()=>setOpen(false)}>
                                Cancel
                            </Button>
                            </Col>
                            </Row>
                            </FormGroup>
                        </Form>
                    </div>
                </PopupWindow>
                :<Button style={{ marginTop: 10, width: '95%' }} disabled={true} className={'border-0 btn-disabled'} color="primary" size="sm" >Change Password</Button>
                }

                {(props.user && props.user.reported_count > 0 && !props.user.is_suspended) ?

                    checkPermissions(props.loginData, 'suspend_account') ?
                        <PopupWindow buttonStyle={{ marginTop: 10, width: '95%' }} handlePopup={(popup) => { setOpen(popup) }} openWindow={open} title={'Suspend Account'} launchButtonText={'Suspend Account'} >
                            <div>
                                <div>
                                    Are you sure? Do you want to suspend this account?
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Button
                                        style={{ padding: 'auto', width: 100, marginTop: 20, marginRight: 10 }}
                                        size="sm"
                                        onClick={() => {
                                            props.suspendAccount({ user_id: userId })
                                        }}
                                        block >
                                        Yes
                                    </Button>
                                    <Button
                                        color="primary"
                                        style={{ padding: 'auto', width: 100, marginTop: 20 }}
                                        size="sm"
                                        onClick={() => setOpen(false)}
                                        block >
                                        No
                                    </Button>
                                </div>
                            </div>
                        </PopupWindow>
                        : <Button style={{ marginTop: 10, width: '95%' }} disabled={true} className={'border-0 btn-disabled'} color="primary" size="sm" >Suspend Account</Button>
                    : (props.user && props.user.is_suspended) ? <>
                        {checkPermissions(props.loginData, 'revoke_suspended_account') ? <PopupWindow buttonStyle={{ marginTop: 10, width: '95%' }} handlePopup={(popup) => { setOpen(popup) }} openWindow={open} title={'UnSuspend Account'} launchButtonText={'UnSuspend Account'} >
                            <div>
                                <div>
                                    Are you sure? Do you want to UnSuspend this account?
                                </div>
                                <div style={{ display: 'flex' }}>
                                    <Button
                                        style={{ padding: 'auto', width: 100, marginTop: 20, marginRight: 10 }}
                                        size="sm"
                                        onClick={() => {
                                            props.suspendAccount({ revoke: 1, user_id: userId })
                                        }}
                                        block >
                                        Yes
                                    </Button>
                                    <Button
                                        color="primary"
                                        style={{ padding: 'auto', width: 100, marginTop: 20 }}
                                        size="sm"
                                        onClick={() => setOpen(false)}
                                        block >
                                        No
                                    </Button>
                                </div>
                            </div>
                        </PopupWindow>
                            : <Button style={{ marginTop: 10, width: '95%' }} disabled={true} className={'border-0 btn-disabled'} color="primary" size="sm" >Revoke Account</Button>}
                    </> : ''
                }
                <AutoFollowBtn userId={userId}/>
                <RssFeedButton userId={userId} />
            </Col>


            <Col sm="12" lg="10">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={(activeTab === 'ABOUT') ? 'active' : ''}
                            onClick={() => handleTab('ABOUT')} >
                            About
                        </NavLink>
                    </NavItem>

                    {checkPermissions(props.loginData, 'followers') &&
                        <NavItem>
                            <NavLink
                                className={(activeTab === 'FOLLOWERS') ? 'active' : ''}
                                onClick={() => handleTab('FOLLOWERS')} >
                                Followers ({props.totalFollowers})
                            </NavLink>
                        </NavItem>
                    }
                    {checkPermissions(props.loginData, 'following') &&
                        <NavItem>
                            <NavLink
                                className={(activeTab === 'FOLLOWING') ? 'active' : ''}
                                onClick={() => handleTab('FOLLOWING')} >
                                Following ({props.totalFollowing})
                            </NavLink>
                        </NavItem>
                    }


                    {checkPermissions(props.loginData, 'searches') &&
                        <NavItem>
                            <NavLink
                                className={(activeTab === 'SEARCHES') ? 'active' : ''}
                                onClick={() => handleTab('SEARCHES')} >
                                Searches ({props.totalSearches})
                            </NavLink>
                        </NavItem>
                    }

                    {checkPermissions(props.loginData, 'favourites') &&
                        <NavItem>
                            <NavLink
                                className={(activeTab === 'BOOKMARKS') ? 'active' : ''}
                                onClick={() => handleTab('BOOKMARKS')} >
                                Bookmarks ({props.totalBookmarks})
                            </NavLink>
                        </NavItem>
                    }
                    <NavItem>
                        <NavLink
                            className={(activeTab === 'CONVERSATION') ? 'active' : ''}
                            onClick={() => handleTab('CONVERSATION')} >
                            Conversation
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} style={{ paddingTop: 30 }}>

                    {checkPermissions(props.loginData, 'followers') &&
                        <TabPane tabId="FOLLOWERS">
                            <Followers userId={userId} />
                        </TabPane>
                    }

                    {checkPermissions(props.loginData, 'following') &&
                        <TabPane tabId="FOLLOWING">
                            <Following userId={userId} />
                        </TabPane>
                    }

                    <TabPane tabId="ABOUT">
                        {(props.user && props.user.is_suspended) ? <div style={{ color: 'red', marginBottom: 30 }}>This account has been suspended</div> : ''}
                        {profileData()}

                        <Row key={'1'}>
                            <Col sm="4" xs={3}>
                                App Version
                            </Col>
                            <Col sm="8" xs={9}>
                                {(props.user && props.user.last_device_used) ? props.user.last_device_used.device_app_version : ''}
                            </Col>
                        </Row>
                        <Row key={'2'}>
                            <Col sm="4" xs={3}>
                                OS Version
                            </Col>
                            <Col sm="8" xs={9}>
                                {(props.user && props.user.last_device_used) ? props.user.last_device_used.device_os : ''}
                            </Col>
                        </Row>

                        {checkPermissions(props.loginData, 'users_locations') && <div>
                            {(props.profileLoading) ?
                                <Skeleton variant="rectangular" width={'100%'} height={300} style={{ borderRadius: 5 }} />
                                : <Row>
                                    <Map
                                        center={{
                                            lat: (props.user && props.user.latitude) ? props.user.latitude : 0,
                                            lng: (props.user && props.user.longitude) ? props.user.longitude : 0,
                                        }}
                                        zoom={12}
                                        scrollWheelZoom={true}
                                        style={{ border: '1px solid', borderRadius: '5px', height: (props.height) ? props.height : 300, width: (props.width) ? props.width : '100%' }}>
                                        <TileLayer
                                            noWrap={true}
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />
                                        <Marker
                                            position={[(props.user && props.user.latitude) ? props.user.latitude : 0, (props.user && props.user.longitude) ? props.user.longitude : 0]}
                                            icon={markerIcon}
                                            key={1}
                                        >
                                        </Marker>
                                    </Map>
                                </Row>
                            }
                        </div>
                        }

                    </TabPane>
                    {checkPermissions(props.loginData, 'searches') &&
                        <TabPane tabId="SEARCHES">
                            <Searches userId={userId} />
                        </TabPane>
                    }
                    {checkPermissions(props.loginData, 'favourites') &&
                        <TabPane tabId="BOOKMARKS">
                            <Favourites userId={userId} />
                        </TabPane>
                    }

                    <TabPane tabId="CONVERSATION">
                        {checkPermissions(props.loginData, 'conversation') ?
                            <Conversatation userId={userId} breakpoint={props.breakpoint} />
                            :
                            <div style={{ margin: '5%' }}>
                                <h4>You need access</h4>
                                <div>
                                    Request access, or switch to an account with access
                                </div>
                                <div style={{ marginTop: 20 }}>
                                    <Input type="textarea" value={requestText} onChange={(e) => setRequestText(e.target.value)} name="requestText" id="requestText" placeholder="Message (optional)" />

                                    <Button
                                        color="primary"
                                        style={{ padding: 'auto', width: 300, marginTop: 20 }}
                                        size="sm"
                                        onClick={() => props.makeAccessRequest({ message: requestText })}
                                        block >
                                        Request Access
                                    </Button>
                                </div>
                            </div>
                        }
                    </TabPane>

                </TabContent>
            </Col>
        </Row>

    );
}

const mapStateToProps = (state) => ({
    totalFollowers: (state.user && state.user.followers &&
        state.user.followers.totalCount) ? state.user.followers.totalCount : 0,
    totalFollowing: (state.user && state.user.following &&
        state.user.following.totalCount) ? state.user.following.totalCount : 0,

    totalSearches: (state.post && state.post.searches && state.post.searches.total_posts) ? state.post.searches.total_posts : 0,
    totalBookmarks: (state.post && state.post.favourites && state.post.favourites.total_posts) ? state.post.favourites.total_posts : 0,
    user: (state.user && state.user.userProfile && state.user.userProfile.userdetails) ? state.user.userProfile.userdetails : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    profileLoading: (state.uiReducer && state.uiReducer.profileLoading) ? state.uiReducer.profileLoading : false,
    accountSuspended: (state.user && state.user.accountSuspended) ? state.user.accountSuspended : null,
    profileUpdated: (state.user && state.user.profileUpdated) ? state.user.profileUpdated : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    appPasswordChanged: (state.user && state.user.appPasswordChanged) ? state.user.appPasswordChanged : null,
});
const mapDispatchToProps = (dispatch) => ({
    getUserProfile: (payload) => dispatch(UserAction.getUserProfile(payload)),
    suspendAccount: (payload) => dispatch(UserAction.suspendAccount(payload)),
    updateProfile: (payload) => dispatch(UserAction.updateProfile(payload)),
    makeAccessRequest: (payload) => dispatch(ChatAction.makeAccessRequest(payload)),
    changeAppPassword: (payload) => dispatch(UserAction.changeAppPassword(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);